import createSvgIcon from '../Utils/CreateSvgIcon';

export const ChevronRight = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.7279 12.0711L8.36398 5.70711L9.7782 4.29289L17.5564 12.0711L9.7782 19.8492L8.36398 18.435L14.7279 12.0711Z"
  />,
  'ChevronRight',
);
